(function() {
  'use strict';
  
  angular
    .module('plugins.free-text-response')
    .controller('FreeTextResponsePollViewController', FreeTextResponsePollViewController);
      
    FreeTextResponsePollViewController.$inject = [
    '$log', 
    '$scope', 
    'pollPluginService'
  ];
    
  function FreeTextResponsePollViewController(
      $log, 
      $scope, 
      pollPluginService
    ) {
    $log = $log.getInstance('FreeTextResponsePollViewController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.hasSubmitted = false;
    vm.submitResponse = submitResponse;

    activate();
    
    function activate() {
    }
    
    function submitResponse(textResponse) {
      if (!textResponse) return
      vm.hasSubmitted = true;      
      pollPluginService.submitResponse($scope.result._id, {textResponse: textResponse})
      vm.textResponse = ""
      $log.info('Submitted text response: ', textResponse);
    }

  }
  
})();